<template>
  <div class="card">
    <img :src="getImageSource()"/>
  </div>
</template>

<script>
export default {
  props: {
    card: String
  },
  methods: {
    getImageSource() {
      return '/static/imgs/' + this.card + ".png";
    }
  }
}
</script>

<style scoped>
  .card > img {
    width: 22px;
  }
</style>
